'use strict';

var keccak256 = require('./keccak256');
var utf8 = require('./utf8');

function id(text) {
    return keccak256(utf8.toUtf8Bytes(text));
}

module.exports = id;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ethers-utils/id.js
// module id = 1867
// module chunks = 0